// import CorsTestButton from "./components/CorsTestButton";
import { Link } from "react-router-dom";

const LINKS = [
  { to: "algorithm-builder", content: "Algorithm Builder" },
  { to: "algorithms", content: "My Algorithms" },
  { to: "table", content: "Colonoscopy Follow-Up Recommendations" },
  { to: "form/h-pylori-algorithm", content: "H. Pylori" },
  {
    to: "form/gastric-intestinal-metaplasia-algorithm",
    content: "Gastric Intestinal Metaplasia",
  },
  { to: "form/pancreatic-cysts-algorithm", content: "Pancreatic Cysts" },
  { to: "crohns", content: "Crohns decision support tool" },
  { to: "colonoscopy-flow", content: "Colonoscopy Flow" },
];

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1 className="text-3xl font-bold underline mb-8">Hello world!</h1>
        <div className="grid grid-cols-7 gap-2">
          <div>
            <div className="min-h-12 inline-flex items-center justify-center">
              Links
            </div>
          </div>
          <div className="divider divider-horizontal justify-self-end" />
          <ul className="flex flex-wrap col-span-5">
            {LINKS.map(({ to, content }, index) => (
              <li key={index}>
                <Link to={to} className="btn btn-link" children={content} />
              </li>
            ))}
          </ul>
        </div>
      </header>
    </div>
  );
}

export default App;
